import * as React from "react";
import {StatuteBlockWrapper,StatuteSectionHeader,StatuteBlock,} from "./statute-elements";
import * as companyData from "../../constants/company-data";
import * as pricingData from "../../constants/pricing-data";
import * as staticUrls from "../../constants/static-urls";

interface ServiceStatuteBlockProps {}

const ServiceStatuteBlock = (props: ServiceStatuteBlockProps) => {
  return (
    <div className="materialize-theme-styles">
      <StatuteBlockWrapper>

        <StatuteSectionHeader ordinal={1} sectionName="Regulamin"/>
        <StatuteBlock>
          <p>
            Regulamin określa warunki funkcjonowania lub korzystania z Serwisu Fakturomania, a także prawa i obowiązki Użytkowników oraz Usługodawcy wraz z zakresem ich odpowiedzialności (dalej "Regulamin").
          </p>
        </StatuteBlock>

        <StatuteSectionHeader ordinal={2} sectionName="Definicje"/>
        <StatuteBlock>
          <ol>
            <li>
              <strong>Usługodawca</strong> - Fakturomania spółka z ograniczoną odpowiedzialnością z siedzibą w Grodzisku Mazowieckim
              przy ul. Generała Leopolda Okulickiego 19B lok. 11, wpisana do rejestru przedsiębiorców
              Krajowego Rejestru Sądowego prowadzonego przez Sąd Rejonowy dla m. st. Warszawy w Warszawie,
              XIV Wydział Gospodarczy pod numerem 0000495029, REGON: 147060749, NIP: 529 18 02 680 o kapitale zakładowym 40.000 zł.
            </li>
            <li>
              <strong>Użytkownik lub Usługobiorca</strong> - korzystający z Serwisu przedsiębiorca w rozumieniu przepisów kodeksu cywilnego,
              w przypadku osoby prawnej działający przez swoje organy zgodnie z przepisami prawa i statutem.
            </li>
            <li>
              <strong>Serwis</strong> - aplikacja internetowa dostępna pod adresem <a href="https://fakturomania.pl/" target="_blank">https://fakturomania.pl/</a> lub <a href="https://app.fakturomania.pl/" target="_blank">https://app.fakturomania.pl/</a>,
              wraz z API, umożliwiająca w szczególności wystawianie faktur, prowadzenie ksiąg rachunkowych, rozliczenia kadrowo-płacowe
              oraz przekazywanie deklaracji, w zakresie i dla podmiotów określonych w §4 Regulaminu.
            </li>
            <li>
              <strong>Cookies</strong> - dane informatyczne, zwłaszcza pliki tekstowe, przechowywane w urządzeniach
              końcowych Użytkowników,
              przeznaczone do korzystania ze stron internetowych. Zawierają nazwę strony internetowej, z której
              pochodzą, czas przechowywania oraz unikalny numer. Zasady stosowania Cookies określa Polityka cookies.
            </li>
            <li>
              <strong>Polityka ochrony danych osobowych</strong> - zasady przetwarzania danych osobowych określone w §10 Regulaminu oraz w Umowie powierzenia.
            </li>
            <li>
              <strong>Kontakt z Usługodawcą</strong> odbywa się przez:
              <ol>
                <li>pocztę elektroniczną na adres info@fakturomania.pl,</li>
                <li>formularz kontaktowy dostępny na stronie Usługodawcy.</li>
              </ol>
            </li>
            <li>
              <strong>Godziny kontaktu</strong> - jest to czas, w którym udzielane jest wsparcie Użytkownikowi. Wsparcie
              dostępne jest od poniedziałku do piątku,
              w godzinach {companyData.FAKTUROMANIA_APP_COMPANY_WORKING_HOURS}, z wyłączeniem dni ustawowo wolnych od
              pracy. W przypadku kontaktu mailowego przewidywany czas odpowiedzi wynosi do 2 dni, nie wliczając sobót
              oraz dni wolnych od pracy.
            </li>
            <li>
              <strong>Oświadczenia i zawiadomienia</strong> - między Użytkownikiem a Usługodawcą dokonywane są elektronicznie:
              <ol>
                <li>
                  przez wysłanie przez Użytkownika e-maila na adres info@fakturomania.pl,
                </li>
                <li>
                  przez wysłanie przez Usługodawcę wiadomości na adres e-mail przypisany do Konta. Użytkownik zobowiązany jest do utrzymywania
                  aktualnego adresu e-mail przypisanego do Konta; oświadczenie wysłane na ostatni adres e-mail przypisany do Konta uważa się
                  za doręczone z chwilą jego wysłania, chyba że Usługodawca otrzymał informację o niedoręczeniu wiadomości.
                </li>
              </ol>
            </li>
            <li>
              <strong>Platformy wsparcia</strong> są to pomocnicze platformy dostępne dla Użytkowników niezależnie od godzin kontaktu.
              <ol>
                <li>
                  <strong>Baza wiedzy</strong> - platforma wsparcia dostępna pod adresem https://pomoc.fakturomania.pl/
                </li>
                <li>
                  <strong>Kanał YouTube Fakturomania</strong> - platforma wsparcia dostępna pod adresem https://www.youtube.com/@Fakturomania
                </li>
              </ol>
            </li>
            <li>
              <strong>Cennik</strong> - wykaz aktualnych cen usług oferowanych przez Usługodawcę, dostępny na stronie
              internetowej Serwisu lub w Serwisie. Cennik może ulegać zmianom, a wszelkie zmiany są komunikowane
              Użytkownikom zgodnie z Regulaminem.
            </li>
            <li>
              <strong>Hasło</strong> - ciąg znaków ustalony przez Użytkownika podczas rejestracji w Serwisie, służący do zabezpieczenia dostępu do konta Użytkownika.
              Użytkownik zobowiązany jest do zachowania hasła w tajemnicy i nieudostępniania go osobom trzecim.
            </li>
            <li>
              <strong>API (Application Programming Interface)</strong> - interfejs programistyczny aplikacji. API jest przede wszystkim specyfikacją wytycznych jak powinna przebiegać
              interakcja między komponentami programowymi. Implementacja API jest zestawem rutyn, protokołów i rozwiązań informatycznych do budowy aplikacji komputerowych.
            </li>
            <li>
              <strong>Polityka rachunkowości</strong> - zbiór dopuszczonych ustawą, wybranych i stosowanych rozwiązań zgodnie z którymi prowadzone są księgi rachunkowe w Serwisie.
            </li>
            <li>
              <strong>RODO</strong> - rozporządzenie Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych
              w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych).
            </li>
            <li>
              <strong>Umowa powierzenia</strong> - umowa powierzenia przetwarzania danych osobowych stanowiąca Załącznik nr 1 do Regulaminu, zawierana pomiędzy
              Użytkownikiem a Usługodawcą w formie elektronicznej wraz z zawarciem Umowy, na podstawie której Usługodawca przetwarza w imieniu Użytkownika
              dane osobowe wprowadzane do Serwisu.
              {" "}(<a href={staticUrls.FAKTUROMANIA_UMOWA_POWIERZENIA_PDF_URL} target="_blank" download>pobierz PDF</a>)
            </li>
            <li>
              <strong>Firma</strong> - przedsiębiorca, dla którego w ramach Konta wystawiane są w Serwisie faktury lub prowadzone są ewidencje, księgi rachunkowe
              lub rozliczenia. W ramach jednego Konta może być obsługiwanych kilka Firm.
            </li>
            <li>
              <strong>Usługi</strong> - usługi świadczone przez Usługodawcę drogą elektroniczną w ramach Serwisu, odpłatne i nieodpłatne, określone w §4 Regulaminu i w Cenniku.
            </li>
            <li>
              <strong>Okres rozliczeniowy</strong> - okres, za który Użytkownik uiścił z góry wynagrodzenie za Usługę odpłatną.
            </li>
            <li>
              <strong>Polityka cookies</strong> - dokument określający zasady stosowania Cookies w Serwisie, dostępny pod adresem <a href="https://fakturomania.pl/cookies" target="_blank">https://fakturomania.pl/cookies</a>.
            </li>
            <li>
              <strong>Konsultant AI</strong> - narzędzie oparte na sztucznej inteligencji, za pomocą którego Usługodawca udziela Użytkownikom wsparcia w czacie dostępnym w Serwisie.
            </li>
          </ol>
        </StatuteBlock>

        <StatuteSectionHeader ordinal={3} sectionName="Wymagania techniczne"/>
        <StatuteBlock>
          <ol>
            <li>
              W celu skorzystania z Serwisu, wymagane są:
              <ol>
                <li>dostęp do Internetu;</li>
                <li>
                  korzystanie z aktualnej wersji jednej z następujących przeglądarek internetowych: Mozilla Firefox, Google Chrome lub Safari,
                  przy czym za aktualną uważa się najnowszą wersję stabilną udostępnioną przez producenta przeglądarki albo wersję bezpośrednio
                  ją poprzedzającą; w innych przeglądarkach lub w wersjach nieaktualnych Serwis może działać nieprawidłowo;
                </li>
                <li>włączona obsługa plików Cookie oraz JavaScript;</li>
                <li>posiadanie czynnego i poprawnie skonfigurowanego konta poczty elektronicznej.</li>
              </ol>
            </li>
            <li>
              Usługodawca nie ponosi odpowiedzialności za problemy wynikające z niespełnienia powyższych wymagań technicznych przez Użytkownika.
            </li>
            <li>
              Usługodawca nie odpowiada za oznaczenie jego e-maili jako spam przez dostawcę usług poczty elektronicznej, z której korzysta Użytkownik.
            </li>
            <li>
              Usługodawca nie ma obowiązku szkolenia Użytkownika w zakresie korzystania z Serwisu. Materiały instruktażowe dotyczące obsługi Serwisu
              pozostają dostępne w Bazie Wiedzy pod adresem <a href="https://pomoc.fakturomania.pl/" target="_blank">https://pomoc.fakturomania.pl/</a>.
            </li>
          </ol>
        </StatuteBlock>

        <StatuteSectionHeader ordinal={4} sectionName="Usługi świadczone drogą elektroniczną"/>
        <StatuteBlock>
          <ol>
            <li>
              Usługodawca świadczy usługi polegające na udostępnieniu Serwisu drogą elektroniczną, w szczególności:
              <ol>
                <li>wystawianie, przechowywanie i wysyłka faktur, w tym przekazywanie ich do Krajowego Systemu e-Faktur (KSeF);</li>
                <li>prowadzenie ksiąg rachunkowych, ewidencji i rejestrów VAT oraz generowanie plików JPK;</li>
                <li>rozliczenia kadrowo-płacowe, w tym listy płac oraz deklaracje PIT i ZUS;</li>
                <li>przekazywanie elektronicznych deklaracji podatkowych na zasadach określonych w §8;</li>
                <li>udostępnianie API na zasadach określonych w §11;</li>
                <li>
                  wsparcie techniczne, w tym z wykorzystaniem narzędzi sztucznej inteligencji na zasadach określonych w pkt 14–16, a w ramach
                  wybranych pakietów – wsparcie księgowe, zgodnie z Cennikiem i z zastrzeżeniem pkt 11.
                </li>
              </ol>
            </li>
            <li>
              Użytkownik zobowiązany jest przed rozpoczęciem korzystania z Serwisu do zapoznania się z Regulaminem, w tym z Umową powierzenia, oraz jego akceptacji.
              Rejestracja w Serwisie Usługodawcy bez akceptacji Regulaminu nie jest możliwa.
              Treść Regulaminu jest udostępniona nieodpłatnie wszystkim Użytkownikom na stronie internetowej Usługodawcy, w taki sposób,
              aby Użytkownik mógł przed rozpoczęciem korzystania z Usług zapoznać się z Regulaminem oraz zapisać go.
            </li>
            <li>
              Serwis jest dedykowanym narzędziem do wystawiania faktur lub dla prowadzenia ksiąg rachunkowych jednostek mikro w rozumieniu art. 3 ust. 1a pkt 1
              ustawy z dnia 29 września 1994 r. o rachunkowości, prowadzących działalność gospodarczą w formie spółki z ograniczoną odpowiedzialnością albo prostej
              spółki akcyjnej na terytorium Rzeczypospolitej Polskiej, o profilu usługowym lub handlowym, posiadających status małego podatnika w rozumieniu
              art. 4a pkt 10 ustawy z dnia 15 lutego 1992 r. o podatku dochodowym od osób prawnych.
              Serwis nie jest odpowiednim narzędziem dla prowadzenia ksiąg rachunkowych podmiotów, które posiadają udziały w osobach prawnych lub których wspólnikami są osoby prawne.
              Serwis nie jest również przeznaczony dla prowadzenia rozliczenia działalności związanej z zyskami kapitałowymi (przykładem jest obrót kryptowalutami lub papierami wartościowymi), o charakterze deweloperskim lub produkcyjnym.
              Użytkownik korzystający z funkcjonalności prowadzenia ksiąg rachunkowych oświadcza, że spełnia kryteria określone w zdaniu pierwszym i nie prowadzi działalności wskazanej w zdaniach drugim i trzecim.
              Usługodawca nie ponosi odpowiedzialności za skutki prowadzenia ksiąg rachunkowych w Serwisie przez podmiot, który tych kryteriów nie spełnia.
              Serwis umożliwia ujęcie transakcji transgranicznych, w szczególności wewnątrzwspólnotowego nabycia towarów, importu usług, wewnątrzwspólnotowej dostawy towarów,
              eksportu towarów oraz świadczenia usług na rzecz kontrahentów z innych państw członkowskich Unii Europejskiej i spoza Unii Europejskiej.
              Z wyjątkiem wewnątrzwspólnotowego nabycia towarów i importu usług Serwis nie jest jednak zalecanym narzędziem dla podmiotów, w których działalności transakcje
              transgraniczne mają istotne znaczenie, z uwagi na rozliczenia walutowe oraz wymogi dokumentacyjne, w szczególności dotyczące potwierdzenia wywozu towarów,
              odprawy celnej i dowodów dostawy. Za prawidłowość rozliczenia takich transakcji, w tym zastosowanie właściwej stawki podatku i posiadanie wymaganych dokumentów, odpowiada Użytkownik.
            </li>
            <li>
              Użytkownik dla zachowania prawidłowości prowadzonych ksiąg rachunkowych jest zobowiązany do przyjęcia polityki rachunkowości udostępnionej pod adresem https://fakturomania.pl/polityka-rachunkowosci lub po zalogowaniu w Serwisie w sekcji „Wzorce dokumentów”.
            </li>
            <li>
              Korzystanie z Serwisu odbywa się na podstawie umowy o świadczenie usług drogą elektroniczną (zwana dalej „Umowa”), zawartej pomiędzy Użytkownikiem a Usługodawcą.
              Do zawarcia Umowy dochodzi poprzez akceptację niniejszego regulaminu wraz z ukończeniem procesu rejestracji. Wraz z zawarciem Umowy dochodzi do zawarcia Umowy powierzenia.
            </li>
            <li>
              Dla aktywacji funkcjonalności wystawiania faktur do liczby 100 w ujęciu miesięcznym (dalej „Plan bezpłatny”), wymagane jest wyłącznie przeprowadzenie rejestracji
              oraz pełnej konfiguracji Konta, które to procesy zostały omówione w §5 Regulaminu. Usługodawca może zmienić zakres Planu bezpłatnego lub zakończyć jego świadczenie,
              informując o tym Użytkowników na adres e-mail przypisany do Konta z co najmniej 30-dniowym wyprzedzeniem; zakończenie świadczenia Planu bezpłatnego następuje w trybie §13 pkt 8.
            </li>
            <li>
              Aktywacji funkcjonalności:
              <ol>
                <li>wystawiania faktur od liczby 101,</li>
                <li>przekazywania faktur do Krajowego Systemu e-Faktur (KSeF) lub,</li>
                <li>prowadzenia ksiąg rachunkowych lub,</li>
                <li>przekazywania za pośrednictwem Serwisu elektronicznych deklaracji podatkowych,</li>
              </ol>
              wymaga, oprócz czynności wskazanych w punkcie poprzedzającym, dokonania zakupu odpowiedniej usługi.
            </li>
            <li>
              Usługodawca nie zwraca zapłaconej przez Użytkownika opłaty za Usługę w przypadku zaprzestania przez Użytkownika korzystania z Serwisu, z zastrzeżeniem § 7 ust. 4
              Umowy powierzenia oraz §13 pkt 8. W przypadku usunięcia przez Usługodawcę funkcjonalności objętej Usługą opłaconą z góry, bez zapewnienia funkcjonalności zastępczej,
              Użytkownikowi przysługuje zwrot części wynagrodzenia proporcjonalnej do niewykorzystanego Okresu rozliczeniowego.
            </li>
            <li>
              Usługodawca może wysyłać Użytkownikowi wiadomości („Komunikaty"), które nie stanowią informacji handlowej, a są niezbędne do korzystania z Usług lub też są konieczne do wyegzekwowania przestrzegania przez Użytkownika przepisów prawa lub Regulaminu.
            </li>
            <li>
              Usługodawca może tworzyć nowe funkcje Serwisu, jak i zmieniać lub modyfikować dotychczasowe, oraz dodawać lub usuwać świadczone usługi.
              Skutki usunięcia funkcjonalności objętej Usługą opłaconą z góry określa pkt 8.
            </li>
            <li>
              Usługi świadczone przez Usługodawcę nie obejmują usług z zakresu usługowego prowadzenia ksiąg rachunkowych, o których mowa w ustawie z dnia 29 września 1994r. o rachunkowości, doradztwa prawnego lub doradztwa podatkowego, o którym mowa w ustawie z dnia 5 lipca 1996 r. o doradztwie podatkowym.
            </li>
            <li>
              Użytkownik zobowiązany jest do korzystania z Serwisu zgodnie z prawem i Regulaminem. Zakazane jest dostarczanie przez Użytkownika treści o charakterze bezprawnym,
              w tym wprowadzanie do Serwisu danych lub dokumentów, do których przetwarzania Użytkownik nie jest uprawniony, oraz wykorzystywanie Serwisu do wystawiania faktur,
              które nie dokumentują rzeczywistych zdarzeń gospodarczych.
            </li>
            <li>
              Serwis jest narzędziem wspierającym Użytkownika w prowadzeniu działalności. Odpowiedzialność za prawidłowość i kompletność danych wprowadzanych do Serwisu,
              kwalifikację podatkową i rachunkową operacji, przyjęcie i stosowanie polityki rachunkowości, prowadzenie ksiąg rachunkowych oraz treść i terminowość składanych
              deklaracji i plików JPK ponosi Użytkownik, a w zakresie obowiązków w dziedzinie rachunkowości – jego kierownik jednostki (art. 4 ust. 5 ustawy z dnia 29 września 1994 r.
              o rachunkowości). Usługodawca nie weryfikuje danych wprowadzanych do Serwisu ani dokonanej przez Użytkownika kwalifikacji operacji.
            </li>
            <li>
              Przy świadczeniu wsparcia technicznego i obsłudze Użytkowników Usługodawca może wykorzystywać narzędzia sztucznej inteligencji, w szczególności do redagowania
              korespondencji kierowanej do Użytkowników oraz w czacie dostępnym w Serwisie. Korespondencja przygotowana z wykorzystaniem tych narzędzi, z wyjątkiem odpowiedzi
              Konsultanta AI w czacie, jest przed wysłaniem sprawdzana i wysyłana przez pracownika lub współpracownika Usługodawcy.
            </li>
            <li>
              W czacie Użytkownik wybiera, czy chce prowadzić rozmowę z konsultantem Usługodawcy, czy z Konsultantem AI. Rozmowa z Konsultantem AI jest oznaczona w sposób
              umożliwiający Użytkownikowi rozpoznanie, że prowadzi ją z systemem sztucznej inteligencji. Użytkownik może w każdym czasie przerwać rozmowę z Konsultantem AI
              i zwrócić się do konsultanta Usługodawcy w godzinach kontaktu, o których mowa w §2 pkt 7. Odpowiedzi Konsultanta AI są generowane automatycznie, bez udziału
              pracownika Usługodawcy, na podstawie treści zapytania oraz materiałów Usługodawcy, w szczególności Bazy wiedzy. Konsultant AI nie ma dostępu do danych zgromadzonych
              w Koncie oraz Użytkownik nie powinien przekazywać w czacie danych osobowych innych niż niezbędne do uzyskania odpowiedzi.
            </li>
            <li>
              Odpowiedzi Konsultanta AI mają charakter informacyjny i pomocniczy, mogą być niepełne lub zawierać błędy i nie stanowią porady prawnej, podatkowej ani rachunkowej (pkt 11).
              Konsultant AI nie składa w imieniu Usługodawcy oświadczeń woli, w szczególności nie rozpatruje reklamacji, nie zmienia warunków Umowy ani cen i nie przyznaje rabatów
              ani zwrotów, oświadczenia takie składają wyłącznie osoby działające w imieniu Usługodawcy. Przed podjęciem decyzji, w szczególności podatkowych lub rachunkowych,
              Użytkownik powinien zweryfikować informacje uzyskane od Konsultanta AI.
            </li>
          </ol>
        </StatuteBlock>

        <StatuteSectionHeader ordinal={5} sectionName="Rejestracja w Serwisie"/>
        <StatuteBlock>
          <ol>
            <li>
              W celu skorzystania z funkcjonalności Serwisu, Użytkownik musi dokonać rejestracji. W wyniku prawidłowo
              przeprowadzonej Rejestracji
              Usługodawca tworzy dla Użytkownika Konto przypisane do numeru (ID), który jest generowany przez
              Usługodawcę przy rejestracji adresu email (dalej: „Konto”).
            </li>
            <li>
              Dla rejestracji konta w Serwisie niezbędne jest przeprowadzenie procesu rejestracyjnego oraz
              konfiguracyjnego zgodnie z materiałami
              instruktażowymi znajdującymi się w Bazie Wiedzy Serwisu w dziale „Pierwsze kroki i organizacja spółki”.
            </li>
            <li>
              W celu rejestracji konta w Serwisie najpierw należy wypełnić formularz rejestracyjny, w którym Użytkownik
              podaje adres email oraz ustanawia hasło do logowania w Serwisie.
              Przy rejestracji przeprowadzanej przy pomocy konta Google wymagane jest jedynie potwierdzenie
              autoryzacji. Usługodawca może udostępniać i wycofywać możliwość rejestracji i logowania za pośrednictwem usług
              podmiotów trzecich. Wycofanie tej możliwości nie pozbawia Użytkownika dostępu do Konta – Użytkownik może ustanowić
              hasło, korzystając z funkcji resetowania hasła dla adresu email przypisanego do Konta.
            </li>
            <li>
              Wraz z rejestracją należy zaakceptować Regulamin, w tym Umowę powierzenia, oraz złożyć oświadczenie o posiadaniu statusu przedsiębiorcy
              w rozumieniu art. 43<sup>1</sup> Kodeksu cywilnego i zawarciu Umowy bezpośrednio w związku z prowadzoną działalnością gospodarczą.
              Usługodawca nie weryfikuje tego oświadczenia, a Użytkownik odpowiada za jego zgodność z prawdą. Informacje o przetwarzaniu danych osobowych zawiera §10 Regulaminu.
            </li>
            <li>
              Po przesłaniu formularza rejestracyjnego Użytkownik otrzymuje na podany adres email wiadomość z linkiem
              aktywacyjnym, Użytkownik musi kliknąć w link aktywacyjny w celu potwierdzenia rejestracji i aktywacji konta.
              Użytkownik uzyskuje dostęp do Konta po dokonaniu jego aktywacji.
            </li>
            <li>
              Użytkownikowi nie wolno umożliwiać korzystania z jego Konta innym osobom, jak i udostępniać danych do tego
              Konta, a login i hasło powinny być należycie zabezpieczone przed dostępem innych osób. Konto jest również niezbywalne.
              Postanowienie zdania pierwszego nie dotyczy nadawania innym osobom, w szczególności pracownikom lub księgowym Użytkownika,
              dostępu do danych w Serwisie za pomocą przeznaczonej do tego funkcjonalności Serwisu.
            </li>
            <li>
              Usługodawca nie ponosi odpowiedzialności za użycie przez Użytkownika opcji „Zapamiętaj hasło”.
            </li>
            <li>
              Dane rejestracyjne podawane przez Użytkownika w czasie przeprowadzania rejestracji, jak i w czasie korzystania z Serwisu muszą być zgodne z prawdą i powinny dotyczyć Użytkownika.
            </li>
            <li>
              Usługodawca zastrzega sobie prawo do odmowy rejestracji Użytkownika, usunięcia konta Użytkownika lub zablokowania dostępu do Serwisu w przypadku
              naruszenia przez Użytkownika postanowień Regulaminu lub obowiązujących przepisów prawa. Z wyjątkiem naruszeń rażących lub zagrażających bezpieczeństwu Serwisu,
              usunięcie Konta lub zablokowanie dostępu następuje po bezskutecznym wezwaniu Użytkownika do zaprzestania naruszeń, przesłanym na adres e-mail przypisany do Konta.
              W przypadku usunięcia Konta z przyczyn leżących po stronie Użytkownika wynagrodzenie uiszczone za Usługi nie podlega zwrotowi. W przypadku usunięcia Konta
              przez Usługodawcę dane Użytkownika są przechowywane i usuwane zgodnie z § 11 ust. 3 Umowy powierzenia.
            </li>
            <li>
              Osoba dokonująca rejestracji lub dodająca Firmę do Konta oświadcza, że jest uprawniona do działania w imieniu przedsiębiorcy, w imieniu którego dokonuje tych czynności,
              a w przypadku braku umocowania odpowiada wobec Usługodawcy na zasadach określonych w art. 103 § 3 Kodeksu cywilnego. Stroną Umowy w zakresie danej Firmy jest
              przedsiębiorca, w imieniu którego dodano Firmę do Konta, a jeżeli Usługi dla Firmy nabywa we własnym imieniu inny przedsiębiorca, w szczególności biuro rachunkowe – ten przedsiębiorca.
            </li>
            <li>
              Użytkownik odpowiada za działania i zaniechania osób, którym nadał dostęp do Konta lub do danych w Serwisie, jak za własne działania i zaniechania,
              a także za nadanie im upoważnień do przetwarzania danych osobowych.
            </li>
          </ol>
        </StatuteBlock>

        <StatuteSectionHeader ordinal={6} sectionName="Wynagrodzenie Usługodawcy"/>
        <StatuteBlock>
          <ol>
            <li>
              Za świadczenie Usług, o których mowa w Regulaminie, Usługodawcy przysługuje wynagrodzenie wskazane w cenniku na stronie internetowej Serwisu https://fakturomania.pl/cennik lub
              po zalogowaniu w Serwisie pod adresem https://app.fakturomania.pl/ustawienia/platnosci
            </li>
            <li>
              Planowane lub dokonane zmiany wysokości wynagrodzenia są Użytkownikom komunikowane na stronie internetowej Serwisu lub po zalogowaniu w Serwisie.
              Zmiana wysokości wynagrodzenia nie dotyczy Okresów rozliczeniowych opłaconych przed dniem jej wejścia w życie.
            </li>
            <li>
              Ceny wskazane w Cenniku są cenami netto, do których dolicza się podatek od towarów i usług według obowiązującej stawki.
            </li>
          </ol>
        </StatuteBlock>

        <StatuteSectionHeader ordinal={7} sectionName="Płatności online"/>
        <StatuteBlock>
          <ol>
            <li>
              Użytkownik może dokonać płatności za usługi oferowane przez Usługodawcę za pomocą operatora płatności
              wyłącznie po pełnej oraz prawidłowej konfiguracji Konta.
            </li>
            <li>
              Obsługę płatności online świadczy PayPro S.A. z siedzibą w Poznaniu przy ul. Kanclerskiej 15, wpisany do
              rejestru przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd Rejonowy Poznań Nowe Miasto i
              Wilda, VIII Wydział Gospodarczy Krajowego Rejestru
              Sądowego pod numerem KRS 0000347935, numerem NIP 7792369887, o kapitale zakładowym wynoszącym 5 476 300,00
              zł, w całości opłaconym oraz do
              rejestru krajowych instytucji płatniczych prowadzonego przez Komisję Nadzoru Finansowego pod numerem UKNF
              IP24/2014.
            </li>
            <li>
              W celu dokonania płatności Użytkownik wybiera jedną z usług świadczonych przez Usługodawcę. W celu
              aktywacji funkcjonalności
              prowadzenia ksiąg rachunkowych Użytkownik musi dokonać wyboru konkretnego okresu kalendarzowego mogącego
              przybrać formę miesięczną, kwartalną, półroczną lub roczną.
              Po wybraniu danego okresu Użytkownik zostanie przekierowany na stronę internetową operatora płatności, w
              której należy postępować zgodnie z dalszymi jego instrukcjami.
            </li>
            <li>
              Płatności online mogą być dokonywane przy użyciu różnych metod płatności dostępnych u operatora płatności,
              w tym blik, kart kredytowych,
              kart debetowych oraz innych metod płatności oferowanych przez operatora.
            </li>
            <li>
              Płatność za usługę nie może zostać wykonana w procedurze mechanizmu podzielonej płatności (MPP), o której mowa w art. 108a ustawy o podatku od towarów i usług.
            </li>
            <li>
              Usługodawca nie ponosi odpowiedzialności za ewentualne problemy techniczne lub operacyjne związane z
              dokonywaniem płatności online przez Użytkownika.
              W przypadku wystąpienia problemów, Użytkownik powinien skontaktować się bezpośrednio z operatorem
              płatności.
            </li>
            <li>
              W przypadku nieudanej transakcji płatniczej, Użytkownik powinien ponowić próbę dokonania płatności lub
              skontaktować się z Usługodawcą w celu uzyskania pomocy.
            </li>
            <li>
              Po dokonaniu płatności Użytkownik otrzyma potwierdzenie dokonania transakcji na podany adres e-mail
              wskazany przy rejestracji konta w Serwisie lub na adres e-mail wskazany w konfiguracji Ustawień Faktur.
            </li>
            <li>
              Faktury za Usługi są wystawiane w Krajowym Systemie e-Faktur (KSeF) zgodnie z przepisami ustawy z dnia 11 marca 2004 r. o podatku od towarów i usług;
              Usługodawca może dodatkowo przesyłać Użytkownikowi ich wizualizację na adres e-mail. Faktura Użytkownikowi zostanie wystawiona po zaksięgowaniu płatności przez operatora płatności.
            </li>
            <li>
              Usługodawca nie ma wpływu na czas księgowania płatności.
            </li>
          </ol>
        </StatuteBlock>

        <StatuteSectionHeader ordinal={8} sectionName="Elektroniczne deklaracje podatkowe"/>
        <StatuteBlock>
          <ol>
            <li>
              Użytkownicy Serwisu mają możliwość skorzystania z modułu eWysyłki służącego przekazywaniu elektronicznych
              deklaracji podatkowych (dalej „edeklaracje”) za pośrednictwem Serwisu.
            </li>
            <li>
              W celu umożliwienia składania deklaracji podatkowych za pośrednictwem Serwisu, niezbędne jest dostarczenie przez Użytkownika właściwemu dla
              Użytkownika Urzędowi Skarbowemu pełnomocnictw do podpisywania elektronicznych deklaracji podatkowych (dalej „UPL-1”) dla osób reprezentujących Usługodawcę.
            </li>
            <li>
              Pełnomocnictwa UPL-1 z Serwisu mogą zostać pobrane przez Użytkownika wyłącznie po zalogowaniu w Serwisie, pełnej konfiguracji konta oraz wykupieniu dodatkowych funkcjonalności.
            </li>
            <li>
              Moduł eWysyłki jest formą przejściową przekazywania deklaracji podatkowych Użytkowników, a został on w systemie zaimplementowany w celu ułatwienia zachowania terminów podatkowych nowo powstałych Podatników.
            </li>
            <li>
              Niniejszy moduł umożliwia przekazywanie w szczególności poniżej wymienionych deklaracji podatkowych; aktualna lista deklaracji obsługiwanych przez moduł jest dostępna w Serwisie.
              <ol>
                <li>JPK_V7(M/K),</li>
                <li>VAT-UE,</li>
                <li>VAT-9M,</li>
                <li>VAT-8,</li>
                <li>CIT-8,</li>
                <li>PIT-11,</li>
                <li>PIT-4R,</li>
                <li>PIT-8C,</li>
                <li>PIT-8AR.</li>
              </ol>
            </li>
            <li>
              W celu prawidłowej obsługi modułu eWysyłki Użytkownik winien postępować zgodnie z materiałami instruktażowymi znajdującymi się w Bazie Wiedzy w dziale „Deklaracje podatkowe”.
            </li>
            <li>
              Przekazywanie Ministerstwu Finansów deklaracji podatkowych Użytkownika za pośrednictwem Serwisu następuje:
              <ol>
                <li>w każdy piątek (z wyjątkiem dni wolnych od pracy, w takim przypadku deklaracja jest przekazywana w następnym dniu roboczym) lub
                </li>
                <li>w terminach podatkowych w przypadku prawidłowo zleconych wysyłek, o których mowa w następnym punkcie lub</li>
                <li>w innych terminach niż wskazane powyżej, na wniosek Użytkownika zgłoszony mailem lub przez czat lub w przypadku zwiększonego obciążenia systemów wynikającego z okresów wzmożonego ruchu podatkowego (np. końcówki miesiąca, kwartału lub roku podatkowego).
                </li>
              </ol>
            </li>
            <li>
              Użytkownik w przypadku chęci skorzystania z modułu eWysyłki zobowiązany jest dostarczyć deklaracje podatkowe do przekazania najpóźniej
              na 2 dni przed terminami oznaczonymi w pkt. 7 lit a. oraz b. W przypadku późniejszego dostarczenia deklaracji Usługodawca nie gwarantuje przekazania
              dokumentów we wskazanych terminach, aczkolwiek dołoży starań w celu przekazania deklaracji z zachowaniem terminów ustawowych.
            </li>
            <li>
              Po przekazaniu deklaracji podatkowych przez Usługodawcę Użytkownicy w ciągu trzech dni roboczych otrzymają Urzędowe Potwierdzenia Odbioru (dalej „UPO”),
              które dostępne będzie w module eWysyłki w postaci numeru referencyjnego zapisanego w dokumencie txt. UPO można pobrać z Serwisu postępując zgodnie
              z materiałem instruktażowym znajdującym się w Bazie Wiedzy o nazwie „Jak pobrać UPO dla e-wysyłek? | Urzędowe poświadczenie odbioru” lub podpowiedzią
              znajdującą się w wymienionym pliku txt.
            </li>
            <li>
              W każdym etapie korzystania z modułu eWysyłki Użytkownik ma dostęp do statusu przekazywanych deklaracji. W Serwisie wyróżnia się 4 statusy:
              <ol>
                <li>Nie podjęto działań – oznacza brak zlecenia przez Użytkownika deklaracji podatkowej do przekazania,</li>
                <li>Zlecono wysyłkę – oznacza zlecenie przez Użytkownika deklaracji podatkowej do przekazania,</li>
                <li>Błąd wysyłki – oznacza brak możliwości przekazania deklaracji z przyczyn niezależnych od Serwisu (najczęściej brak złożonych pełnomocnictw UPL-1 lub błąd danych konfiguracyjnych),
                </li>
                <li>Wysyłka zakończona – oznacza prawidłowe przekazanie deklaracji podatkowej ministerstwu finansów oraz uzyskanie UPO.
                </li>
              </ol>
            </li>
            <li>
              Odpłatność usługi:
              <ol>
                <li>Usługa przekazania edeklaracji jest odpłatna zgodnie z cennikiem, o którym mowa w §6 Regulaminu.
                </li>
                <li>Płatność za wybrany pakiet można dokonać po zalogowaniu w Serwisie.
                </li>
              </ol>
            </li>
            <li>
              Odpowiedzialność Usługodawcy:
              <ol>
                <li>
                  Usługodawca nie ponosi odpowiedzialności za treść deklaracji przekazywanych w ramach Usługi eWysyłki. Dane wygenerowane w ramach Serwisu nie będą w
                  jakikolwiek sposób modyfikowane czy weryfikowane przez Usługodawcę.
                </li>
                <li>
                  Odpowiedzialność za poprawność i adekwatność przekazywanych deklaracji leży po stronie Użytkownika.
                </li>
                <li>
                  Usługodawca zapewnia ochronę informacji przetwarzanych w ramach Usługi eWysyłki.
                </li>
                <li>
                  Usługodawca dołoży staranności w celu terminowego przekazania dokumentacji do Ministerstwa Finansów, jednakże nie ponosi odpowiedzialności za czynniki,
                  które mogą zakłócić lub uniemożliwić przekazanie edeklaracji Użytkownika. Takie czynniki niezależne od działania Serwisu są wymienione w §9 Regulaminu.
                </li>
              </ol>
            </li>
          </ol>
        </StatuteBlock>

        <StatuteSectionHeader ordinal={9} sectionName="Odpowiedzialność"/>
        <StatuteBlock>
          <ol>
            <li>
              Usługodawca nie ponosi odpowiedzialności za wszelkie zdarzenia i szkody wynikłe z:
              <ol>
                <li>
                  niedostosowania się Użytkownika do wymogów technicznych niezbędnych do współpracy z systemem teleinformatycznym, którym Usługodawca się posługuje (§3),
                </li>
                <li>
                  kradzieży Konta, obciążeń, zakupów, usunięcia lub kradzieży plików na skutek włamania, udostępnienia danych osobom trzecim,
                </li>
                <li>
                  braku możliwości dostępu do Serwisu, wynikającego z przyczyn od Usługodawcy niezależnych, zwłaszcza siły wyższej, działań wojennych, ataku terrorystycznego, pożaru,
                  zalania serwerowni, ataku hakerskiego, awarii, przyczyn leżących po stronie Access providerów, dostawców Internetu oraz przyczyn leżących po stronie innych
                  osób trzecich (podmioty świadczące usługi telekomunikacyjne, hostingowe, bankowe, pocztowe, kurierskie, poczty elektronicznej, rejestracji i utrzymywania
                  domen i inne podobne usługi),
                </li>
                <li>
                  złośliwego lub naruszającego prawo działania, lub zaniechania, lub niedozwolonego korzystania przez jakiegokolwiek Użytkownika,
                </li>
                <li>
                  przerwy technicznej w funkcjonowaniu Serwisu, w przypadku planowanej, bieżącej obsługi Serwera oraz oprogramowania Serwisu,
                </li>
                <li>
                  przyczyn leżących po stronie innego oprogramowania niż Serwis,
                </li>
                <li>
                  odrzucenia wysyłanych wiadomości e-mail przez serwery pocztowe inne niż Usługodawcy, na przykład w skutek działania filtrów, blokad lub awarii tych systemów,
                </li>
                <li>
                  w innych przypadkach określonych w Regulaminie.
                </li>
              </ol>
            </li>
            <li>
              Usługodawca nie ponosi odpowiedzialności wobec Użytkownika za skutki wykorzystania informacji zamieszczonych w Serwisie, Bazie wiedzy, kanale YouTube
              oraz informacji udzielonych przez Konsultanta AI.
            </li>
            <li>
              Usługodawca nie odpowiada za treść publikowaną w niniejszym Serwisie w zakresie, w jakim podmioty trzecie mogłyby doznać szkody majątkowej lub niemajątkowej,
              podejmując (lub nie podejmując) jakiekolwiek czynności na podstawie treści zamieszczonych w Serwisie. Treść nie stanowi opinii prawnej, ani
              jakiejkolwiek porady prawnej i nie może być podstawą do podjęcia jakiejkolwiek decyzji biznesowej. Treść Serwisu nie stanowi informacji o
              stanie obowiązującego prawa. Treść Serwisu stanowi wyłącznie odzwierciedlenie poglądów prowadzących Serwis (dalej: Autorzy). Autorzy zastrzegają
              prawo do zmiany tekstów oraz poglądów wyrażonych w Serwisie, w szczególności w przypadku zmiany prawa lub praktyki orzeczniczej sądów i organów administracji.
            </li>
            <li>
              Usługodawca zastrzega, że korzystanie z Serwisu odbywa się wyłącznie na koszt i ryzyko osoby go odwiedzającej.
            </li>
            <li>
              Serwis stanowi jedynie wsparcie dla prowadzenia przez Użytkownika szeroko rozumianej działalności gospodarczej i
              tym samym Usługodawca nie ponosi odpowiedzialności związanej z tak prowadzoną przez Użytkownika działalnością gospodarczą.
            </li>
            <li>
              Usługodawca nie ponosi odpowiedzialności za szkody wynikające z użycia lub błędnego działania Serwisu lub nieprawidłowego
              korzystania z Serwisu przez Użytkownika i innej osoby odwiedzającej Serwis.
            </li>
            <li>
              Usługodawca zastrzega sobie prawo do przerwy technicznej w funkcjonowaniu Serwisu, w przypadku bieżącej obsługi
              Serwisu oraz jego oprogramowania, aktualizowania oprogramowania, wprowadzania nowych funkcjonalności, prac konserwacyjnych lub naprawczych.
              Bieżąca przerwa techniczna polega na czasowym wyłączeniu działania Serwisu lub niektórych jego funkcji.
              Usługi będą realizowane po zakończeniu tejże przerwy. Za zdarzenia wynikłe z powyższych Usługodawca nie ponosi odpowiedzialności.
            </li>
            <li>
              Usługodawca ma prawo czasowego ograniczania funkcji Serwisu, udostępniania go w wybranych godzinach lub wprowadzania ograniczeń pod względem liczby Użytkowników online,
              jeżeli brak limitów mógłby negatywnie wpłynąć na ciągłość i stabilność świadczonych Usług.
            </li>
            <li>
              Usługodawca zastrzega sobie prawo do umieszczania w każdej części Serwisu treści reklamowych w dowolnej formie.
            </li>
            <li>
              W zakresie przetwarzania danych osobowych powierzonych przez Użytkownika odpowiedzialność Usługodawcy określa § 12 Umowy powierzenia,
              który ma w tym zakresie pierwszeństwo przed pkt 1–9.
            </li>
            <li>
              Odpowiedzialność Usługodawcy wobec Użytkownika z tytułu niewykonania lub nienależytego wykonania Umowy, w tym Umowy powierzenia, ogranicza się
              do szkody rzeczywistej i nie obejmuje utraconych korzyści. Ograniczenie nie dotyczy szkody wyrządzonej umyślnie.
            </li>
            <li>
              W każdym przypadku całkowita odpowiedzialność Usługodawcy wobec Użytkownika z tytułu Umowy, w tym Umowy powierzenia, niezależnie od podstawy prawnej
              roszczenia, jest ograniczona łącznie do kwoty wynagrodzenia netto przypadającego za Usługi świadczone na rzecz Użytkownika za okres 6 miesięcy
              poprzedzających zdarzenie, z którego wynika szkoda, nie mniej jednak niż 100 zł. Jeżeli na okres ten nie przypadało wynagrodzenie za Usługi,
              w szczególności gdy Użytkownik korzystał wyłącznie z Planu bezpłatnego, Usługodawca nie ponosi odpowiedzialności. Ograniczenie i wyłączenie
              odpowiedzialności, o których mowa w zdaniach poprzedzających, nie dotyczą szkody wyrządzonej umyślnie.
            </li>
          </ol>
        </StatuteBlock>

        <StatuteSectionHeader ordinal={10} sectionName="Ochrona danych osobowych"/>
        <StatuteBlock>
          <p>
            <strong>A. Dane osobowe, których administratorem jest Usługodawca</strong>
          </p>
          <ol>
            <li>
              Administratorem danych osobowych Użytkowników będących osobami fizycznymi prowadzącymi działalność gospodarczą, w tym wspólnikami spółek cywilnych,
              a także osób reprezentujących Użytkowników, osób kontaktowych oraz osób, którym Użytkownik nadał dostęp do danych w Serwisie, jest Usługodawca –
              w zakresie danych przetwarzanych w związku z rejestracją w Serwisie, zawarciem i wykonaniem Umowy oraz kontaktem z Usługodawcą. W sprawach dotyczących
              danych osobowych można kontaktować się z Usługodawcą pod adresem e-mail info@fakturomania.pl lub pisemnie na adres siedziby Usługodawcy.
            </li>
            <li>
              Usługodawca przetwarza dane osobowe w następujących celach i na następujących podstawach prawnych:
              <ol>
                <li>
                  zawarcie i wykonanie Umowy, w tym rejestracja i prowadzenie Konta, świadczenie usług, obsługa płatności, wsparcie techniczne oraz rozpatrywanie
                  reklamacji – art. 6 ust. 1 lit. b RODO, a w odniesieniu do osób reprezentujących Użytkownika, osób kontaktowych i osób, którym Użytkownik nadał
                  dostęp do danych w Serwisie – art. 6 ust. 1 lit. f RODO, przy czym prawnie uzasadnionym interesem Usługodawcy jest wykonanie Umowy zawartej z Użytkownikiem;
                </li>
                <li>
                  wypełnienie obowiązków prawnych ciążących na Usługodawcy, w szczególności wynikających z przepisów prawa podatkowego i o rachunkowości – art. 6 ust. 1 lit. c RODO;
                </li>
                <li>
                  realizacja prawnie uzasadnionych interesów Usługodawcy (art. 6 ust. 1 lit. f RODO), którymi są: zapewnienie bezpieczeństwa Serwisu i przeciwdziałanie
                  nadużyciom, ustalenie, dochodzenie i obrona roszczeń, komunikacja z Użytkownikami w sprawach dotyczących Serwisu, marketing bezpośredni własnych usług
                  Usługodawcy oraz prowadzenie analiz i statystyk służących rozwojowi Serwisu;
                </li>
                <li>
                  przesyłanie informacji handlowych za pomocą środków komunikacji elektronicznej oraz kontakt telefoniczny w celach marketingowych – wyłącznie po uzyskaniu
                  odrębnej zgody, jeżeli wymagają jej przepisy prawa.
                </li>
              </ol>
            </li>
            <li>
              Podanie danych osobowych jest dobrowolne, lecz niezbędne do rejestracji w Serwisie i wykonania Umowy. Przetwarzanie danych w celach określonych w pkt 2 lit. a–c
              nie odbywa się na podstawie zgody. Zgody na przetwarzanie danych osobowych udzielone w procesie rejestracji przed dniem 9 października 2026 r. przestają stanowić
              podstawę przetwarzania danych w tych celach z dniem 16 października 2026 r., a ich cofnięcie nie skutkuje zawieszeniem Konta. Użytkownik zobowiązany jest
              do niezwłocznej aktualizacji swoich danych w przypadku ich zmiany.
            </li>
            <li>
              Odbiorcami danych osobowych mogą być: podmioty przetwarzające dane na zlecenie Usługodawcy, w szczególności dostawcy usług hostingu (OVH), poczty elektronicznej
              (Google, Mailjet) i systemu obsługi zgłoszeń i czatu (Freshworks) oraz narzędzi sztucznej inteligencji wykorzystywanych w obsłudze Użytkowników (Anthropic); operator
              płatności PayPro S.A.; podmioty świadczące na rzecz Usługodawcy usługi księgowe, prawne i doradcze; organy publiczne uprawnione do otrzymania danych na podstawie
              przepisów prawa; dostawca usługi logowania (Google) – w przypadku rejestracji lub logowania za jego pośrednictwem; dostawcy narzędzi analitycznych i reklamowych –
              zgodnie z Polityką cookies.
            </li>
            <li>
              Dane osobowe przechowywane są na serwerach zlokalizowanych w Polsce i we Francji. Korespondencja z Usługodawcą, w tym zgłoszenia kierowane do Usługodawcy,
              jest przetwarzana z wykorzystaniem poczty elektronicznej Google Workspace oraz systemu obsługi zgłoszeń Freshdesk i czatu Freshchat, co wiąże się z przekazywaniem danych
              do państw trzecich, w szczególności do USA. W przypadku Freshworks Inc. – na podstawie standardowych klauzul umownych przyjętych przez Komisję Europejską
              (art. 46 ust. 2 lit. c RODO), a w przypadku Google – na podstawie decyzji Komisji Europejskiej stwierdzającej odpowiedni stopień ochrony w ramach
              EU-US Data Privacy Framework (art. 45 RODO) oraz standardowych klauzul umownych. Rozmowy w czacie oraz korespondencja przygotowywana z wykorzystaniem
              narzędzi sztucznej inteligencji są przekazywane do Anthropic, PBC z siedzibą w USA na podstawie standardowych klauzul umownych przyjętych przez Komisję
              Europejską (art. 46 ust. 2 lit. c RODO). Przed przekazaniem, z treści usuwane są lub zastępowane identyfikatorami zastępczymi: dane identyfikujące,
              w szczególności imiona i nazwiska, nazwy podmiotów i numery telefonów (pseudonimizacja). Dostawca nie wykorzystuje przekazanych danych do trenowania modeli.
            </li>
            <li>
              Dane osobowe są przechowywane:
              <ol>
                <li>przez czas obowiązywania Umowy, a po jej rozwiązaniu – do upływu okresu przedawnienia roszczeń;</li>
                <li>w zakresie dokumentacji podatkowej i rachunkowej – przez okres wymagany przepisami prawa;</li>
                <li>w przypadku przetwarzania na podstawie prawnie uzasadnionego interesu – do czasu skutecznego wniesienia sprzeciwu;</li>
                <li>w przypadku przetwarzania na podstawie zgody – do czasu jej cofnięcia.</li>
              </ol>
            </li>
            <li>
              Osobie, której dane dotyczą, przysługuje prawo dostępu do danych, ich sprostowania, usunięcia, ograniczenia przetwarzania i przenoszenia (w zakresie danych
              przetwarzanych w sposób zautomatyzowany na podstawie umowy lub zgody), prawo wniesienia sprzeciwu wobec przetwarzania danych na podstawie prawnie uzasadnionego
              interesu – w odniesieniu do marketingu bezpośredniego w każdym czasie – a także prawo cofnięcia zgody w dowolnym momencie, bez wpływu na zgodność z prawem
              przetwarzania dokonanego przed jej cofnięciem.
            </li>
            <li>
              Osobie, której dane dotyczą, przysługuje prawo wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych (ul. Stawki 2, 00-193 Warszawa).
            </li>
            <li>
              Usługodawca nie podejmuje wobec Użytkowników decyzji opartych wyłącznie na zautomatyzowanym przetwarzaniu danych, w tym profilowaniu, które wywołują wobec nich
              skutki prawne lub w podobny sposób istotnie na nich wpływają. Narzędzia sztucznej inteligencji, w tym Konsultant AI, nie są wykorzystywane do profilowania
              Użytkowników ani do podejmowania wobec nich takich decyzji.
            </li>
            <li>
              Dane identyfikacyjne i kontaktowe osób reprezentujących Użytkownika, osób kontaktowych oraz osób, którym Użytkownik nadał dostęp do danych w Serwisie,
              Usługodawca otrzymuje od Użytkownika. Dane Użytkowników mogą być również pobierane z publicznie dostępnych rejestrów, w szczególności CEIDG, KRS, rejestru
              REGON oraz wykazu podatników VAT. Użytkownik zobowiązuje się udostępnić treść niniejszego paragrafu osobom, których dane przekazuje Usługodawcy.
            </li>
            <li>
              Usługodawca stosuje środki techniczne i organizacyjne zapewniające ochronę przetwarzanych danych osobowych odpowiednią do zagrożeń oraz kategorii danych
              objętych ochroną, a także prowadzi rejestr czynności przetwarzania oraz rejestr naruszeń ochrony danych osobowych. Zasady stosowania plików cookies określa Polityka cookies.
            </li>
          </ol>
          <p>
            <strong>B. Dane osobowe powierzone Usługodawcy przez Użytkownika</strong>
          </p>
          {/* numeracja punktów w §10 jest ciągła dla części A i B */}
          <ol start={12}>
            <li>
              W zakresie danych osobowych wprowadzanych do Serwisu przez Użytkownika lub na jego polecenie, w szczególności danych kontrahentów, pracowników i współpracowników
              Użytkownika, administratorem danych jest Użytkownik, a Usługodawca przetwarza te dane wyłącznie w imieniu Użytkownika, jako podmiot przetwarzający, na zasadach
              określonych w Umowie powierzenia.
            </li>
            <li>
              Umowa powierzenia zostaje zawarta w formie elektronicznej wraz z zawarciem Umowy i obowiązuje przez czas jej obowiązywania. Treść <a href={staticUrls.FAKTUROMANIA_UMOWA_POWIERZENIA_PDF_URL} target="_blank">Umowy powierzenia</a> oraz aktualny
              Wykaz Podprzetwarzających (Załącznik nr 1 do Umowy powierzenia) są dostępne w Serwisie oraz pod adresem <a href="https://fakturomania.pl/regulamin" target="_blank">https://fakturomania.pl/regulamin</a> w sposób
              umożliwiający ich pobranie, utrwalenie i odtworzenie.
            </li>
            <li>
              Użytkownik, jako administrator danych, odpowiada za zgodność z prawem przetwarzania danych osobowych wprowadzanych do Serwisu, w tym za posiadanie podstawy prawnej
              ich przetwarzania oraz spełnienie obowiązku informacyjnego wobec osób, których dane dotyczą, a szkodę poniesioną z tego tytułu przez Usługodawcę naprawia na zasadach
              określonych w § 12 ust. 4 Umowy powierzenia.
            </li>
          </ol>
        </StatuteBlock>

        <StatuteSectionHeader ordinal={11} sectionName="Zasady korzystania z API"/>
        <StatuteBlock>
          <ol>
            <li>
              Usługodawca udostępnia Użytkownikom API (Application Programming Interface), które umożliwia integrację z Serwisem i automatyzację wybranych procesów, które dostępne jest pod adresem <a href="https://api.fakturomania.pl/" target="_blank">https://api.fakturomania.pl/</a>
            </li>
            <li>
              W celu uzyskania dostępu do API oraz możliwości integracji Użytkownik musi posiadać w pełni skonfigurowane konto w Serwisie.
            </li>
            <li>
              API może być wykorzystywane wyłącznie w sposób zgodny z jego przeznaczeniem oraz niniejszym Regulaminem.
            </li>
            <li>
              Niedozwolone jest korzystanie z API w sposób, który mógłby zakłócić działanie Serwisu lub spowodować nadmierne obciążenie jego infrastruktury.
            </li>
            <li>
              Użytkownik zobowiązany jest do przestrzegania limitów zapytań określonych przez Usługodawcę. Przekroczenie limitów może skutkować czasowym lub stałym zablokowaniem Użytkownikowi dostępu do API. W celu uzyskania informacji o aktualnym limicie zapytań należy skontaktować się z obsługą Serwisu w sposób wskazany w §2 pkt 6. Regulaminu.
            </li>
            <li>
              W przypadku przekroczenia limitów zapytań, o których mowa w pkt. 5. Usługodawca zastrzega możliwość nałożenia dodatkowej opłaty za korzystanie z API przez Użytkownika zgodnie z Cennikiem.
            </li>
            <li>
              Usługodawca może wprowadzać zmiany do API, w tym zmieniać jego funkcjonalność, format danych oraz zasady korzystania.
            </li>
            <li>
              Usługodawca może dokonywać modyfikacji, zawieszenia lub zakończenia dostępu do API w dowolnym czasie. Jeżeli jest to możliwe, przed dokonaniem takich czynności Usługodawca dołoży starań w celu poinformowania Użytkowników korzystających z API o planowanych czynnościach.
            </li>
            <li>
              Usługodawca nie ponosi odpowiedzialności za jakiekolwiek szkody mogące wyniknąć z korzystania z API przez Użytkownika.
            </li>
            <li>
              Klucze i inne dane uwierzytelniające API stanowią dane dostępowe do Konta. Użytkownik odpowiada za ich zabezpieczenie oraz za działania podjęte z ich użyciem.
              Przekazywanie danych za pośrednictwem API do systemów zewnętrznych skonfigurowanych przez Użytkownika następuje na jego polecenie i na jego odpowiedzialność.
            </li>
          </ol>
        </StatuteBlock>

        <StatuteSectionHeader ordinal={12} sectionName="Tryb postępowania reklamacyjnego"/>
        <StatuteBlock>
          <ol>
            <li>
              Jeżeli Użytkownik uważa, że Usługi nie są realizowane przez Usługodawcę lub są realizowane niezgodnie z postanowieniami Regulaminu, może złożyć reklamację drogą elektroniczną, wysyłając wiadomość na adres e-mail info@fakturomania.pl. Wiadomość winna zostać zatytułowana jako „Reklamacja“
              oraz zawierać nazwę przedsiębiorcy, numer firmy nadany przez Serwis, adres e-mail Użytkownika wraz ze szczegółowym opisem stanu faktycznego.
            </li>
            <li>
              Usługodawca rozpatruje reklamację w ciągu 10 (dziesięciu) dni roboczych od dnia doręczenia reklamacji.
            </li>
          </ol>
        </StatuteBlock>

        <StatuteSectionHeader ordinal={13} sectionName="Usunięcie Konta"/>
        <StatuteBlock>
          <ol>
            <li>
              Użytkownik ma prawo do rezygnacji z Usług świadczonych przez Usługodawcę przez usunięcie Konta w Serwisie w dowolnym momencie, bez podawania przyczyny.
            </li>
            <li>
              Usunięcie Konta może zostać dokonane samodzielnie przez Użytkownika, za pośrednictwem funkcjonalności dostępnej po zalogowaniu się do Konta, w ustawieniach danych Użytkownika.
            </li>
            <li>
              Usunięcie Konta przez Użytkownika jest dobrowolne i nie uprawnia go do zwrotu jakichkolwiek opłat uiszczonych za Usługi świadczone w ramach Serwisu, w tym opłat za pakiety, subskrypcje lub inne funkcjonalności płatne, z zastrzeżeniem §4 pkt 8.
            </li>
            <li>
              Usunięcie Konta stanowi rozwiązanie Umowy oraz polecenie usunięcia danych osobowych powierzonych Usługodawcy. Przez 30 dni od dnia usunięcia Konta jest ono zablokowane,
              a Użytkownik może zwrócić się do Usługodawcy o jego przywrócenie, co oznacza wznowienie Umowy na dotychczasowych warunkach. Po upływie tego terminu dane są trwale
              usuwane w terminach określonych w § 11 Umowy powierzenia, a usunięcie Konta staje się nieodwracalne.
            </li>
            <li>
              Przed usunięciem Konta Użytkownik powinien pobrać dane i dokumenty zgromadzone w Serwisie, w szczególności faktury w formacie PDF lub ZIP, pliki JPK, deklaracje,
              raporty i wydruki, w celu wykonania ciążących na nim obowiązków przechowywania dokumentacji podatkowej, rachunkowej i pracowniczej. Usługodawca nie ponosi
              odpowiedzialności za skutki niepobrania danych przed upływem terminu, o którym mowa w pkt 4.
            </li>
            <li>
              W przypadku rozwiązania lub wygaśnięcia Umowy z innej przyczyny niż usunięcie Konta przez Użytkownika, Usługodawca przechowuje dane przez okres określony
              w § 11 ust. 3 Umowy powierzenia, w którym Użytkownik może wystąpić o umożliwienie ich pobrania.
            </li>
            <li>
              Usługodawca może wypowiedzieć Umowę Użytkownikowi, który przez okres 24 miesięcy nie zalogował się do Konta i nie posiada opłaconych usług, z zachowaniem 30-dniowego
              okresu wypowiedzenia, przesyłając oświadczenie o wypowiedzeniu na adres e-mail przypisany do Konta. Wypowiedzenie nie wywołuje skutku, jeżeli przed upływem okresu
              wypowiedzenia Użytkownik zaloguje się do Konta.
            </li>
            <li>
              Usługodawca może wypowiedzieć Umowę w całości albo w zakresie Planu bezpłatnego lub określonej Usługi, z zachowaniem 30-dniowego okresu wypowiedzenia, przesyłając
              oświadczenie na adres e-mail przypisany do Konta, w szczególności w przypadku zakończenia świadczenia Planu bezpłatnego lub danej Usługi albo zakończenia działalności
              Serwisu. W przypadku wypowiedzenia Umowy w zakresie Usługi opłaconej z góry Usługodawca zwraca Użytkownikowi część wynagrodzenia proporcjonalną do niewykorzystanego
              Okresu rozliczeniowego. Do danych Użytkownika stosuje się pkt 6.
            </li>
          </ol>
        </StatuteBlock>

        <StatuteSectionHeader ordinal={14} sectionName="Prawo autorskie i Prawo własności intelektualnej"/>
        <StatuteBlock>
          <ol>
            <li>
              Wszelkie treści udostępniane przez Usługodawcę (zwłaszcza znaki towarowe, utwory, zdjęcia, multimedia, teksty, kod źródłowy, układ i wybór szaty graficznej)
              zamieszczone w Serwisie są chronione, w szczególności na podstawie ustawy z dnia 4 lutego 1994 r. o prawie autorskim i prawach pokrewnych oraz przepisów
              o ochronie znaków towarowych. Wyłączne prawa autorskie do Serwisu należą do Usługodawcy.
            </li>
            <li>
              Zabronione jest wykorzystywanie treści w sposób niezgodny z Regulaminem, a zwłaszcza kopiowanie ich w celu uzyskania korzyści majątkowej.
            </li>
            <li>
              Usługodawca nie nabywa żadnych praw do treści, danych i dokumentów wprowadzanych do Serwisu przez Użytkownika i korzysta z nich wyłącznie w zakresie niezbędnym
              do świadczenia Usług, a w zakresie danych osobowych – na zasadach określonych w Umowie powierzenia.
            </li>
            <li>
              Usługodawca udziela Użytkownikowi niewyłącznej i nieprzenoszalnej licencji na korzystanie z Serwisu przez czas obowiązywania Umowy, w zakresie niezbędnym
              do korzystania z Usług zgodnie z Regulaminem. Zakazane jest w szczególności dekompilowanie, dezasemblowanie lub inne odtwarzanie kodu Serwisu, z wyjątkiem
              przypadków dozwolonych przez bezwzględnie obowiązujące przepisy prawa, a także automatyczne pobieranie danych z Serwisu z pominięciem udostępnionych funkcjonalności i API.
            </li>
          </ol>
        </StatuteBlock>

        <StatuteSectionHeader ordinal={15} sectionName="Postanowienia końcowe"/>
        <StatuteBlock>
          <ol>
            <li>
              Zmiana Regulaminu:
              <ol>
                <li>
                  Usługodawca może zmienić Regulamin, w tym Umowę powierzenia, z ważnych przyczyn, którymi są w szczególności: zmiana przepisów prawa lub ich wykładni
                  wynikającej z orzeczeń sądów, decyzji, rekomendacji lub wytycznych właściwych organów; zmiana zakresu, sposobu świadczenia lub funkcjonalności usług,
                  w tym wprowadzenie nowych usług; zmiany technologiczne lub konieczność zapewnienia bezpieczeństwa Serwisu i przetwarzanych danych; konieczność usunięcia
                  niejasności, błędów lub omyłek; zmiana danych Usługodawcy;
                </li>
                <li>
                  o zmianie Regulaminu Usługodawca powiadamia Użytkowników co najmniej 7 dni przed dniem wejścia zmian w życie, przesyłając informację o zmianach wraz
                  z treścią zmienionego Regulaminu lub odnośnikiem do niej na adres e-mail przypisany do Konta oraz publikując ją w Serwisie;
                </li>
                <li>
                  Użytkownik, który nie akceptuje zmian, może przed dniem ich wejścia w życie rozwiązać Umowę ze skutkiem natychmiastowym poprzez usunięcie Konta lub
                  złożenie oświadczenia na adres info@fakturomania.pl; brak rozwiązania Umowy przed tym dniem oznacza akceptację zmian;
                </li>
                <li>
                  zmiany wynikające z obowiązku dostosowania Regulaminu do przepisów prawa lub rozstrzygnięć właściwych organów, jeżeli nie jest możliwe zachowanie terminu
                  określonego w lit. b, a także zmiany wyłącznie korzystne dla Użytkowników lub o charakterze redakcyjnym, mogą wejść w życie w terminie krótszym niż
                  określony w lit. b, nie wcześniej jednak niż z dniem powiadomienia Użytkowników;
                </li>
                <li>
                  zmiana Wykazu Podprzetwarzających następuje w trybie określonym w Umowie powierzenia i nie stanowi zmiany Regulaminu.
                </li>
              </ol>
            </li>
            <li>
              Umowa o świadczenie usług drogą elektroniczną zawierana jest w języku polskim.
            </li>
            <li>
              Prawem właściwym dla świadczenia usług drogą elektroniczną jest prawo polskie.
            </li>
            <li>
              W przypadku wątpliwości co do interpretacji przepisów Regulaminu, Użytkownik powinien zwrócić się o wyjaśnienie do Usługodawcy.
            </li>
            <li>
              Do wszelkich sporów wynikłych z niniejszego Regulaminu wyłącznie właściwy jest sąd dla siedziby Usługodawcy.
            </li>
            <li>
              Jeżeli jakiekolwiek postanowienie Regulaminu okazałoby się nieważne, nie uchybia to ważności pozostałych postanowień.
            </li>
            <li>
              Integralną część Regulaminu stanowi Załącznik nr 1 – Umowa powierzenia przetwarzania danych osobowych wraz z jej załącznikami.
            </li>
            <li>
              Użytkownik wyraża zgodę na przeniesienie przez Usługodawcę praw i obowiązków wynikających z Umowy, w tym z Umowy powierzenia, na podmiot, który przejmie
              prowadzenie Serwisu. Usługodawca informuje Użytkownika o przeniesieniu z co najmniej 7-dniowym wyprzedzeniem; Użytkownik może w takim przypadku rozwiązać
              Umowę ze skutkiem natychmiastowym.
            </li>
            <li>
              Regulamin obowiązuje w niniejszym brzmieniu od dnia 9 października 2026 r. Wobec Użytkowników, którzy zawarli Umowę przed tym dniem, Regulamin w niniejszym
              brzmieniu, w tym Umowa powierzenia, obowiązuje od dnia 16 października 2026 r., chyba że przed tym dniem Użytkownik rozwiąże Umowę. Do tego dnia stosuje się
              wobec nich Regulamin w dotychczasowym brzmieniu.
            </li>
          </ol>
        </StatuteBlock>
      </StatuteBlockWrapper>
    </div>
  )
};

export default ServiceStatuteBlock



// WEBPACK FOOTER //
// ./src/layouts/statute-block/service-statute-block.tsx